export const isNaNish = value => {
  return value === null || value === undefined || isNaN(value);
};
